import * as React from 'react';
import TextField from 'react-md/lib/TextFields';
import { NumberValidator } from '../Calculation/NumberValidator';

interface Props {
    id: string;
    placeholder?: string;
    clearOnFocus: boolean;
    step: number;
    min?: number;
    max?: number;
    value?: number;
    fullWidth?: boolean;
    onChange: (newValue: number | undefined) => void;
}

interface State {
    localFieldValue: string;
    focused: boolean;
}

export class NumericField extends React.Component<Props, State> {
    constructor(props: Readonly<Props>) {
        super(props);

        this.state = {
            localFieldValue: this.formatValue(this.props.value),
            focused: false
        };
    }

    public render() {
        let renderValue: string;
        if (this.state.focused) {
            renderValue = this.state.localFieldValue;
        } else {
            renderValue = this.formatValue(this.props.value);
        }
        return <TextField id={this.props.id} className="numeric-field" placeholder={this.props.placeholder} step={this.props.step} min={this.props.min} max={this.props.max} value={renderValue} type="number" onChange={this.onChange} onFocus={this.onFocus} onBlur={this.onBlur} fullWidth={!!this.props.fullWidth} />
    }

    protected formatValue(value: number | undefined): string {
        const exp = Math.log10(this.props.step);
        const numberOfDigits = exp >= 0 ? 0 : Math.ceil(Math.abs(exp));
        return value === undefined || isNaN(value) ? "" : value.toFixed(numberOfDigits);
    }    

    protected get onChange() {
        return this._onChange;
    }

    protected get onFocus() {
        return this._onFocus;
    }

    protected get onBlur() {
        return this._onBlur;
    }

    private _onChange = (value: string) => {
        this.setState({localFieldValue: value});
    };

    private _onFocus = () => {
        this.setState({focused: true, localFieldValue: this.props.clearOnFocus ? "" : this.formatValue(this.props.value)});
    }
    
    private _onBlur = () => {
        const sanitized = this.sanitizeValue(this.state.localFieldValue);
        let newValue: number | undefined = parseFloat(sanitized);

        // Revert to previous value on blur if invalid
        if (newValue === undefined || !this.valueIsValid(newValue)) {
            newValue = this.props.value;
        }

        this.setState({localFieldValue: "", focused: false}, () => {
            this.props.onChange(newValue);
        });
    };

    private sanitizeValue(value: string) {
        return value.replace(/[^0-9\.]/g,'');
    }    

    private valueIsValid(value: number) {
        return new NumberValidator(this.props).isValid(value);
    }
}
